import { render, staticRenderFns } from "./EventoFloatingPlayer.vue?vue&type=template&id=78b0e20f&scoped=true&"
import script from "./EventoFloatingPlayer.vue?vue&type=script&lang=js&"
export * from "./EventoFloatingPlayer.vue?vue&type=script&lang=js&"
import style0 from "./EventoFloatingPlayer.vue?vue&type=style&index=0&id=78b0e20f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b0e20f",
  null
  
)

export default component.exports